import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    tabName(type) {
        switch (type) {
            case 'ABOUT':
                return  __('Om virksomheden');
            case 'JOBS':
                return  __('Ledige job');
            case 'EVALUATIONS':
                return  __('Evalueringer');
            case 'TRAINEE':
                return  __('Elev');
            case 'GRADUATE':
                return  __('Graduate');
            case 'PAY':
                return  __('Løn & regnskab');
            case 'JOBADSTATISTICS':
                return  __('Annoncestatistik');
            case 'NEWS':
                return  __('Nyheder');
        }
    },
    evaluationsCount: (count) =>
        __x('{count} evalueringer', { count }),
    followersCount: (count) =>
        __x('{count} følgere', { count }),
    seeEvaluations: () =>
        __('Se evalueringer'),
    highlightedRating: () =>
        __('Fremhævet evaluering'),
    statusName(status) {
        switch (String(status)) {
            case '1':
                return  __('Nuværende medarbejder');
            case '0':
                return  __('Tidligere medarbejder');
        }
    },
    similarCompany: () =>
        __('Lignende virksomhed'),
    jobads: () =>
        __('Jobannoncer'),
};
